var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { container, singleton } from 'tsyringe';
var AppEvent = /** @class */ (function () {
    function AppEvent() {
    }
    return AppEvent;
}());
export { AppEvent };
var Dispatcher = /** @class */ (function () {
    function Dispatcher() {
        this.handlers = {};
    }
    Dispatcher.prototype.listen = function (event, handler) {
        if (!this.handlers.hasOwnProperty(event.toString())) {
            this.handlers[event.toString()] = [];
        }
        this.handlers[event.toString()].push(handler);
        return this;
    };
    Dispatcher.prototype.dispatch = function (event) {
        if (this.handlers.hasOwnProperty(event.constructor.toString())) {
            for (var _i = 0, _a = this.handlers[event.constructor.toString()]; _i < _a.length; _i++) {
                var handler = _a[_i];
                handler(event);
            }
        }
    };
    Dispatcher.prototype.removeListener = function (event, handler) {
        var index = this.handlers[event.toString()].findIndex(function (h) { return h === handler; });
        this.handlers[event.toString()].splice(index, 1);
        return this;
    };
    Dispatcher = __decorate([
        singleton()
    ], Dispatcher);
    return Dispatcher;
}());
export { Dispatcher };
export function dispatch(event) {
    container.resolve(Dispatcher).dispatch(event);
}
